import { URLPaths } from "app/core/mips/common/utilities/urlPaths.config";
import { Constants } from "app/core/mips/common/utilities/constants.config";

export class mobileHeaderItems {
    static shortcutItems = {
        [URLPaths.ROUTE_TIME_ENTRY_ACTUALS] : Constants.NAV_TIME_ENTRY_ACTUALS,
        [URLPaths.ROUTE_EXPENSE_ENTRY_ACTUALS] : Constants.NAV_EXPENSE_ENTRY,
        [URLPaths.ROUTE_TIME_DICER_ACTUALS] : Constants.NAV_TIME_DICER,
        [URLPaths.ROUTE_SUSTAINABILITY_ACTUALS] : Constants.NAV_SUSTAINABILITY,
        [URLPaths.ROUTE_FINANCE_EXPENSE]: Constants.NAV_EXPENSE_ENTRY
    }
}